/* ==========================================================================
   Blanket Statement — customizer engine

   THE ONE DISTINCTION THAT MATTERS
   --------------------------------
   The BLANKET is reoriented by the Landscape / Portrait buttons: a 62x54
   becomes a 54x62. The blanket, its fringe and the photo all turn together,
   because that is one physical object. Same SKU, same price — production
   simply feeds the file to the loom rotated.

   Everything else turns the PHOTO INSIDE the blanket, which keeps its shape
   because we cannot weave a crooked rectangle. Two controls do this and they
   add up into one angle:
     state.quarter    Rotate 90 degrees. Whole quarter turns, for a photo that
                      came off the camera on its side.
     state.straighten The fine slider, for a tilted horizon.
   Use angle() wherever the photo is drawn. Never either one on its own.

   Presentation tilt, drape, shadow and weave texture are screen-only and are
   never exported.
   ========================================================================== */
(function () {
  'use strict';

  var DEG = Math.PI / 180;
  var clamp = function (v, lo, hi) { return Math.max(lo, Math.min(hi, v)); };

  /* ---- Funnel events ------------------------------------------------------
     Ad visitors reached the product page and none added to cart, and there was
     no way to tell whether they never tried, failed at the photo step, or saw
     the price and left. Each step below publishes a Shopify customer event
     (bs_*) that a Customer events pixel can forward to Meta. Fire-and-forget:
     analytics must never break the designer, so every call is guarded. */
  var T0 = Date.now();
  var fired = {};
  function track(name, data, repeatable) {
    if (!repeatable && fired[name]) return;
    fired[name] = true;
    var payload = data || {};
    payload.secondsOnPage = Math.round((Date.now() - T0) / 1000);
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish(name, payload);
      }
    } catch (e) { /* never block the sale */ }
  }

  function BSCustomizer(root) {
    this.root = root;
    this.cfg = JSON.parse(root.querySelector('[data-bsc-config]').textContent);

    this.el = {
      stage:    root.querySelector('[data-bsc-stage]'),
      blanket:  root.querySelector('[data-bsc-blanket]'),
      window:   root.querySelector('[data-bsc-window]'),
      img:      root.querySelector('[data-bsc-img]'),
      empty:    root.querySelector('[data-bsc-empty]'),
      shadow:   root.querySelector('[data-bsc-shadow]'),
      file:     root.querySelector('[data-bsc-file]'),
      sizes:    root.querySelectorAll('[data-bsc-size]'),
      orient:   root.querySelectorAll('[data-bsc-orient]'),
      zoom:     root.querySelector('[data-bsc-zoom]'),
      zoomOut:  root.querySelector('[data-bsc-zoom-val]'),
      straight: root.querySelector('[data-bsc-straighten]'),
      straightOut: root.querySelector('[data-bsc-straighten-val]'),
      rotate:   root.querySelector('[data-bsc-rotate]'),
      priceOut: root.querySelector('[data-bsc-price]'),
      confirm:    root.querySelector('[data-bsc-confirm]'),
      confirmImg: root.querySelector('[data-bsc-confirm-img]'),
      confirmGo:  root.querySelector('[data-bsc-confirm-go]'),
      ack:        root.querySelector('[data-bsc-ack]'),
      ackText:    root.querySelector('[data-bsc-ack-text]'),
      flip:     root.querySelector('[data-bsc-flip]'),
      reset:    root.querySelector('[data-bsc-reset]'),
      change:   root.querySelector('[data-bsc-change]'),
      quality:  root.querySelector('[data-bsc-quality]'),
      status:   root.querySelector('[data-bsc-status]'),
      woven:    root.querySelector('[data-bsc-woven]'),
      wovenWrap:root.querySelector('[data-bsc-woven-wrap]'),
      wovenRange:root.querySelector('[data-bsc-woven-range]'),
      wovenLbl: root.querySelector('[data-bsc-woven-label]'),
      wovenCtl: root.querySelector('[data-bsc-woven-ctl]'),
      loader:   root.querySelector('[data-bsc-loader]'),
      uploadErr: root.querySelector('[data-bsc-uploaderr]'),
      sizesWrap: root.querySelector('.bsc__sizes'),
      sizesRail: root.querySelector('[data-bsc-sizes-rail]'),
      sizesThumb: root.querySelector('[data-bsc-sizes-thumb]'),
      wovenToggle:root.querySelector('[data-bsc-woven-toggle]'),
      submit:   root.querySelector('[data-bsc-submit]'),
      variantIn:root.querySelector('[data-bsc-variant]'),
      uploadCta:root.querySelector('[data-bsc-upload-cta]'),
      ackInline:root.querySelector('[data-bsc-ack-inline]')
    };

    /* Simple mode starts on the plain photo; the woven view is opt-in through
       the "See it woven" checkbox. The weave is still built once at add to
       cart either way, because that build is the only thing that measures
       _detailRisk, which rides on the order. If the markup ever lacks a woven
       canvas, a detached one gives that build somewhere to draw. */
    this.simple = !!this.cfg.simple;
    if (this.simple) {
      this.wovenOff = true;
      if (!this.el.woven) this.el.woven = document.createElement('canvas');
    }

    this.img = null;               // HTMLImageElement once loaded
    this.state = {
      sizeIndex: 0,
      orientation: 'landscape',
      zoom: 1,
      minZoom: 1,
      panX: 0, panY: 0,
      quarter: 0,
      straighten: 0,
      flipX: 1,
      wovenReveal: 0
    };

    this.bind();
    this.selectSize(this.startingSizeIndex(), true);
    this.setSubmitEnabled(false);
  }

  /* Which size to open on.

     The sizes section links each card as /products/x?variant=123 so a customer
     who picks "Queen Bed" on the homepage should land in the customizer on the
     Queen. Without this they landed on whatever the block's default was, which
     silently threw away the choice they had just made — the handoff looked
     like it worked because Shopify's own variant selector updated. */
  BSCustomizer.prototype.startingSizeIndex = function () {
    var sizes = this.cfg.sizes || [];
    try {
      var wanted = new URLSearchParams(window.location.search).get('variant');
      if (wanted) {
        for (var i = 0; i < sizes.length; i++) {
          if (String(sizes[i].variantId) === String(wanted)) return i;
        }
      }
    } catch (e) { /* older browsers fall through to the default */ }

    var d = parseInt(this.cfg.defaultSizeIndex, 10);
    if (isNaN(d) || d < 0 || d >= sizes.length) d = 0;
    return d;
  };

  /* ---- Size / orientation -------------------------------------------- */

  BSCustomizer.prototype.size = function () {
    return this.cfg.sizes[this.state.sizeIndex];
  };

  /* The price of the size actually selected, shown next to Add to cart.
     Same three-state treatment as everywhere else: struck grey former price,
     red sale price, plain ink when there is no sale. */
  BSCustomizer.prototype.paintPrice = function () {
    var out = this.el.priceOut;
    if (!out) return;
    var s = this.size();
    if (!s || !s.price) { out.textContent = ''; return; }
    if (s.compareAt) {
      out.innerHTML =
        '<span class="bs-price">' +
          '<s class="bs-price__was">' + s.compareAt + '</s>' +
          '<span class="bs-price__now">' + s.price + '</span>' +
        '</span>';
    } else {
      out.innerHTML = '<span class="bs-price">' + s.price + '</span>';
    }
  };

  // Effective blanket dimensions in inches, after orientation.
  BSCustomizer.prototype.dims = function () {
    var s = this.size();
    return this.state.orientation === 'portrait'
      ? { w: s.h, h: s.w }
      : { w: s.w, h: s.h };
  };

  BSCustomizer.prototype.isSquare = function () {
    var s = this.size();
    return s.w === s.h;
  };

  BSCustomizer.prototype.selectSize = function (i, silent) {
    var fr = this.img ? (this.userFraming || this.captureFraming()) : null;
    this.state.sizeIndex = i;
    var s = this.size();

    // A square blanket has no orientation to choose.
    if (this.isSquare()) this.state.orientation = 'landscape';

    this.el.sizes.forEach(function (b, j) {
      b.setAttribute('aria-pressed', String(j === i));
    });
    this.el.orient.forEach(function (b) {
      b.disabled = this.isSquare();
    }, this);

    if (this.el.variantIn && s.variantId) this.el.variantIn.value = s.variantId;
    this.paintPrice();

    this.applyRatio();
    if (!silent) {
      if (fr) this.applyFraming(fr); else this.refit();
      track('bs_size_changed', { size: s.name || '', hasPhoto: !!this.img }, true);
    }
    this.syncOrientButtons();
  };

  BSCustomizer.prototype.setOrientation = function (o) {
    if (this.isSquare()) return;
    if (this.state.orientation === o) return;
    var fr = this.img ? (this.userFraming || this.captureFraming()) : null;
    this.state.orientation = o;
    this.applyRatio();
    if (fr) this.applyFraming(fr); else this.refit();
    this.syncOrientButtons();
  };

  /* "Rotate 90" turns the PHOTO a quarter turn inside the blanket. It used to
     swap the blanket between landscape and portrait, which is what the
     Landscape / Portrait buttons directly above it already do — so the control
     duplicated its neighbour and did not do what its label said.

     The framing is captured before the turn and re-applied after it, so the
     point of the photo you had centred stays centred and the zoom re-solves
     against the new angle instead of snapping back to a cover fit. */
  BSCustomizer.prototype.rotate90 = function () {
    if (!this.img) return;
    var fr = this.captureFraming();
    this.state.quarter = (this.state.quarter + 90) % 360;
    if (fr) {
      this.applyFraming(fr);
    } else {
      this.clampAll(); this.syncSliders(); this.render();
    }
    this.rememberFraming();
  };

  BSCustomizer.prototype.syncOrientButtons = function () {
    var cur = this.state.orientation;
    this.el.orient.forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.bscOrient === cur));
    });
  };

  /* Every size is drawn at ONE pixels-per-inch scale, so a bigger blanket is
     visibly bigger.

     Previously the blanket filled the available width and let the aspect ratio
     decide its height, which meant only the proportions changed, not the size.
     That inverted reality on neighbouring products: the Full Bed (72x54,
     ratio 1.333) rendered TALLER than the Queen (84x62, ratio 1.355), so the
     larger blanket looked smaller. The scale is set by the largest size this
     product offers, so that one fills the stage and the rest sit below it in
     true proportion. */
  BSCustomizer.prototype.applyRatio = function () {
    /* The size row's content can change width when the layout does, and a
       ResizeObserver on the row only sees its own box. */
    if (this.syncSizeRail) this.syncSizeRail();

    var d = this.dims();
    this.el.blanket.style.setProperty('--bsc-ratio', d.w + ' / ' + d.h);

    var stage = this.el.stage;
    if (stage) {
      var cs = window.getComputedStyle(stage);
      var padX = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
      var padY = parseFloat(cs.paddingTop)  + parseFloat(cs.paddingBottom);
      var availW = stage.clientWidth - padX;

      /* Height comes from a budget, not from the stage's current height.
         Measuring the stage and then resizing it would feed back on itself,
         and a fixed tall stage left most of a phone screen empty: on a 375px
         viewport the width always binds, so a 503px-tall stage held a 184px
         blanket and half a screen of nothing. */
      /* On the three-column desktop layout the stage is a column of its own and
         can afford to be taller. On a phone it cannot: the stage is sticky there
         and a tall one would leave no room for the controls underneath it. */
      var wide = this.root && this.root.clientWidth >= 1040;
      var maxStageH = wide
        ? Math.min(window.innerHeight * 0.78, 760)
        : Math.min(window.innerHeight * 0.62, 620);
      /* Simple mode has to fit the whole job on one screen, so the stage gets
         a smaller share: on a phone the sizes and the button sit under it. */
      if (this.simple) {
        maxStageH = this.root.clientWidth >= 760
          ? Math.min(window.innerHeight * 0.66, 600)
          : Math.min(window.innerHeight * 0.36, 320);
      }
      var availH = maxStageH - padY;

      // Largest inch dimension offered, either way round, so rotating never
      // pushes a blanket outside the stage.
      var maxInch = 0;
      (this.cfg.sizes || []).forEach(function (sz) {
        maxInch = Math.max(maxInch, sz.w, sz.h);
      });
      maxInch = maxInch || Math.max(d.w, d.h);

      if (availW > 0 && availH > 0) {
        var fringeAllowance = 26;   // fringe sits outside the blanket box
        var ppi = (Math.min(availW, availH) - fringeAllowance) / maxInch;
        var tw = d.w * ppi, th = d.h * ppi;
        this.el.blanket.style.width  = tw + 'px';
        this.el.blanket.style.height = th + 'px';
        this.el.blanket.style.maxWidth = 'none';

        /* The stage hugs the blanket rather than holding a fixed box. The
           scale is still global, so sizes stay comparable; only the empty
           space goes. */
        stage.style.height = Math.round(th + padY + fringeAllowance) + 'px';

        /* Remember the TARGET size. The blanket animates to it over 450ms, and
           anything that measures the DOM in between gets a size that is on its
           way somewhere — which was shifting the restored crop by about 5%. */
        this._frameTarget = { w: tw, h: th };
      }
    }

    if (this.el.shadow) this.el.shadow.style.width = (d.w >= d.h ? 62 : 44) + '%';
    this.positionFringe();
  };

  /* All four edges carry fringe, but the warp ends and the remaining colours
     are on different pairs. Turning the blanket 90 degrees moves the warp, so
     the two colour sets swap with it. */
  BSCustomizer.prototype.positionFringe = function () {
    var d = this.dims();
    this.root.classList.toggle('is-fringe-swapped', d.w < d.h);
  };

  /* ---- Geometry -------------------------------------------------------- */

  BSCustomizer.prototype.frame = function () {
    /* Prefer the size the blanket is heading for over the size it happens to
       be at right now: the box animates for 450ms after a size change, and the
       crop maths must not depend on when it is asked.

       offsetWidth/Height, NOT getBoundingClientRect, for the fallback: the
       blanket carries a presentation rotateX() that foreshortens its projected
       height, and measuring the projection makes the crop disagree with the
       file we weave. */
    if (this._frameTarget && this._frameTarget.w > 0) return this._frameTarget;
    var el = this.el.window;
    return { w: el.offsetWidth, h: el.offsetHeight };
  };

  // Smallest zoom at which the photo still covers the blanket at this angle.
  /* The photo's total rotation: quarter turns plus the fine straighten slider.
     Everything that draws, measures or clamps the photo uses this. */
  BSCustomizer.prototype.angle = function () {
    return this.state.quarter + this.state.straighten;
  };

  /* The zoom floor: below this the photo stops covering the blanket and the
     exported file would carry blank edges, which the mill has no way to weave.
     Every path that sets zoom clamps against this — slider, wheel, pinch,
     auto-fit and framing restore — so it cannot be got under from the UI.

     The 1.002 is not slop. The bound below lands *exactly* on the cover line,
     and floating point then leaves the photo a fraction of a pixel short at one
     edge: measured at worst 0.26px on a 2952x4000 export. Invisible, but still a
     sliver of blank in a production file, so the floor over-covers by 0.2%
     instead of sitting on the line. On a 4000px file that is 8px of margin and
     about 0.2% of crop, which no one will see.

     For a rotated photo this uses the bounding box of the turned frame, which
     is conservative — it can ask for slightly more cover than strictly needed,
     and erring that way is the safe direction. */
  var COVER_SAFETY = 1.002;

  BSCustomizer.prototype.minZoomFor = function (angleDeg) {
    if (!this.img) return 1;
    var f = this.frame();
    var a = Math.abs(angleDeg * DEG);
    var c = Math.abs(Math.cos(a)), s = Math.abs(Math.sin(a));
    return COVER_SAFETY * Math.max(
      (f.w * c + f.h * s) / this.img.naturalWidth,
      (f.w * s + f.h * c) / this.img.naturalHeight
    );
  };

  // Keep zoom above the cover threshold and pan inside the photo.
  BSCustomizer.prototype.clampAll = function () {
    if (!this.img) return;
    var st = this.state;
    st.minZoom = this.minZoomFor(this.angle());
    st.zoom = Math.max(st.zoom, st.minZoom);

    var f = this.frame();
    var a = this.angle() * DEG;
    var c = Math.abs(Math.cos(a)), s = Math.abs(Math.sin(a));
    var k = st.zoom;

    // Frame centre expressed in photo coordinates.
    var cosA = Math.cos(-a), sinA = Math.sin(-a);
    var px = (-st.panX * cosA - -st.panY * sinA) / k;
    var py = (-st.panX * sinA + -st.panY * cosA) / k;

    // Half-extents of the frame's bounding box, in photo pixels.
    var hx = (f.w * c + f.h * s) / (2 * k);
    var hy = (f.w * s + f.h * c) / (2 * k);

    var lx = Math.max(0, this.img.naturalWidth  / 2 - hx);
    var ly = Math.max(0, this.img.naturalHeight / 2 - hy);
    px = clamp(px, -lx, lx);
    py = clamp(py, -ly, ly);

    // Back to screen-space pan.
    var cosB = Math.cos(a), sinB = Math.sin(a);
    st.panX = -(px * cosB - py * sinB) * k;
    st.panY = -(px * sinB + py * cosB) * k;
  };

  /* ---- Framing -----------------------------------------------------------
     A photo is auto-fitted when it is first added: scaled to cover the blanket
     and centred, which is the best default without knowing what the subject is.

     After that the customer's framing is theirs. Changing size used to call
     refit() and wipe it, so anyone comparing a Classic against a Queen lost
     the crop they had just set. Framing is now captured as two things that do
     not depend on the blanket's shape — which point of the photo sits at the
     centre, and how much of the photo's width the blanket spans — and restored
     afterwards. Zoom and pan are re-clamped to the new shape, so the photo
     still covers it and the subject stays put.
     -------------------------------------------------------------------- */

  /* The customer's framing is stored ONCE, when they actually move something,
     and every size change re-derives from that stored intent.

     Re-capturing after each change instead looked equivalent but was not: a
     wider blanket has to clamp an off-centre crop inward, and capturing the
     clamped result made the next change start from it. Cycling through the six
     sizes drifted the focal point by 0.14 and never came back. Re-deriving from
     the original intent every time means a size can clamp without that clamp
     becoming permanent. */
  BSCustomizer.prototype.rememberFraming = function () {
    if (this.img) this.userFraming = this.captureFraming();
  };

  BSCustomizer.prototype.captureFraming = function () {
    if (!this.img) return null;
    var st = this.state, f = this.frame();
    var a = this.angle() * DEG;
    var cosA = Math.cos(-a), sinA = Math.sin(-a);
    var px = (-st.panX * cosA + st.panY * sinA) / st.zoom;
    var py = (-st.panX * sinA - st.panY * cosA) / st.zoom;
    return {
      fx: px / (this.img.naturalWidth  / 2),   // focal point, -1..1
      fy: py / (this.img.naturalHeight / 2),
      coverage: f.w / (st.zoom * this.img.naturalWidth),
      straighten: st.straighten,
      flipX: st.flipX
    };
  };

  BSCustomizer.prototype.applyFraming = function (fr) {
    if (!fr || !this.img) return;
    var st = this.state, f = this.frame();

    st.straighten = fr.straighten;
    st.flipX = fr.flipX;
    st.minZoom = this.minZoomFor(this.angle());

    // Same share of the photo across the blanket as before, never below cover.
    var wanted = f.w / (fr.coverage * this.img.naturalWidth);
    st.zoom = Math.max(st.minZoom, wanted);

    // Put the same point of the photo back at the centre.
    var px = fr.fx * (this.img.naturalWidth  / 2);
    var py = fr.fy * (this.img.naturalHeight / 2);
    var a = this.angle() * DEG;
    var cosB = Math.cos(a), sinB = Math.sin(a);
    st.panX = -(px * cosB - py * sinB) * st.zoom;
    st.panY = -(px * sinB + py * cosB) * st.zoom;

    this.clampAll();
    this.syncSliders();
    this.render();
  };

  BSCustomizer.prototype.refit = function () {
    if (!this.img) return;
    this.userFraming = null;
    /* A quarter turn survives a re-fit. It is a deliberate statement about which
       way up the photo goes, not part of the framing, so Auto-fit re-frames
       within it rather than undoing it. Only the fine straighten is cleared.
       A NEW photo does clear the turn — see loadFile. */
    this.state.straighten = 0;
    if (this.el.straight) this.el.straight.value = 0;
    this.state.zoom = this.minZoomFor(this.angle());
    this.state.panX = this.state.panY = 0;
    this.clampAll();
    this.syncSliders();
    this.render();
  };

  /* ---- Render ---------------------------------------------------------- */

  /* ---- Woven preview ----------------------------------------------------
     A halftone of the current crop against the loom's yarn palette. Rebuilt on
     a debounce rather than per frame: it is a full-image pass, and it only
     needs to be right once the crop stops moving.
     -------------------------------------------------------------------- */

  /* The loom animation has to be long enough to read as an animation. Below
     about half a second it registers as a flicker, which looks like a fault
     rather than like work being done. */
  var MIN_LOOM = 550;

  BSCustomizer.prototype.scheduleWoven = function () {
    var self = this;
    if (this.wovenOff) return;
    if (!this.el.woven || !window.BSWeaveSim || !this.img) return;
    clearTimeout(this._wovenT);
    this._wovenT = setTimeout(function () { self.rebuildWoven(); }, 180);
  };

  /* Rebuilds used to call buildWoven() straight out, with no loom shown. That
     is why flipping the orientation felt like the page had seized: the weave is
     a synchronous pass over up to 977,500 threads, so the tab simply stopped
     for the length of it with nothing on screen to say why. The work is the
     same work — it just runs behind the loom now, and the loom is held long
     enough to be seen. */
  BSCustomizer.prototype.rebuildWoven = function () {
    var self = this;
    clearTimeout(this._wovenHideT);
    this.showLoader(true);

    var start = Date.now(), ran = false;
    function run() {
      if (ran) return;
      ran = true;
      /* finally, not a plain call: if the weave throws, the loom must still
         come down. A stuck spinner reads as a dead page. */
      try {
        self.buildWoven();
      } finally {
        var wait = Math.max(0, MIN_LOOM - (Date.now() - start));
        self._wovenHideT = setTimeout(function () { self.showLoader(false); }, wait);
      }
    }

    /* Let the loom paint a frame before the main thread is taken, but never
       depend on that happening: requestAnimationFrame does not fire in a
       background tab, so a customer who flips the orientation and then switches
       apps would come back to a spinner that never resolves. The timeout is the
       guarantee; the frames are only the nicety. */
    requestAnimationFrame(function () { requestAnimationFrame(run); });
    setTimeout(run, 120);
  };

  /* The palette arrives from the theme editor as a string of JSON typed by a
     human, so it is parsed defensively: bad input falls back to the default
     yarns rather than breaking the customizer. */
  BSCustomizer.prototype.palette = function () {
    var p = this.cfg.yarnPalette;
    if (!p) return null;
    if (typeof p === 'string') {
      try { p = JSON.parse(p); } catch (e) { return null; }
    }
    if (!Array.isArray(p) || p.length < 2) return null;
    var ok = p.every(function (c) {
      return Array.isArray(c) && c.length === 3 && c.every(function (n) {
        return typeof n === 'number' && n >= 0 && n <= 255;
      });
    });
    return ok ? p : null;
  };

  /* the mill publish an exact pixel canvas for each product, and one pixel is
     one warp/weft crossover. Simulating on their grid rather than a density I
     worked out myself means the preview is quantised exactly where the loom
     quantises. Sizes they publish are used verbatim; the rest fall back to
     13.71 px/inch, the density their 62-inch products run at. */
  BSCustomizer.prototype.canvasGrid = function () {
    var d = this.dims();
    var long = Math.max(d.w, d.h), short = Math.min(d.w, d.h);

    /* the mill's official canvas chart, all six sizes, keyed long x short.
       Density is NOT constant between products — 54 inches is 768px on the
       54x54 and 54x40, but 716px on the 62x54 — so these are used verbatim
       rather than calculated. Two sizes were derived before this chart
       arrived and both were wrong (54x54 came out 740x740 against a real
       768x768; 54x40 came out 740x548 against 768x545). */
    var CHART = {
      '84x62': [1150, 850],
      '72x54': [1025, 768],
      '62x62': [850, 850],
      '62x54': [850, 716],
      /* The 54x54 and 54x40 were withdrawn on 29 Sep 2026: FiberArt does not
         weave them on demand and silently upsized a 54x54 order to a 62x62.
         Their grids are kept because the mill supplied them and they were hard
         to get, so the sizes can be restored without asking again. No variant
         uses them, so they are inert. */
      '54x54': [768, 768],
      '54x40': [768, 545]
    };

    var hit = CHART[long + 'x' + short];
    var across, downN;
    if (hit) {
      across = (d.w >= d.h) ? hit[0] : hit[1];
      downN  = (d.w >= d.h) ? hit[1] : hit[0];
    } else {
      var tpi = this.cfg.threadsPerInch || 13.71;
      across = Math.round(d.w * tpi);
      downN  = Math.round(d.h * tpi);
    }
    return { across: across, down: downN, published: !!hit };
  };

  /* outWidthOverride asks for a larger weave and returns it without painting the
     page. Kept because it is occasionally useful, but note the sim clamps the
     result to one pixel per two threads whatever is asked for — so on the sizes
     shipped today it returns the same canvas the live preview already has. */
  BSCustomizer.prototype.buildWoven = function (outWidthOverride) {
    if (!this.img || !window.BSWeaveSim) return;
    var d = this.dims();

    // Render the crop exactly as the customer framed it, then weave that.
    var W = 900;
    var H = Math.round(W * d.h / d.w);
    /* Reused, not allocated per rebuild — see the note in bs-weave-sim.js. This
       is the fifth canvas that used to be thrown away on every size change. */
    var flat = this._flatCanvas || (this._flatCanvas = document.createElement('canvas'));
    if (flat.width !== W) flat.width = W;
    if (flat.height !== H) flat.height = H;
    var fx = flat.getContext('2d');
    fx.clearRect(0, 0, W, H);
    fx.fillStyle = '#EDE6DC'; fx.fillRect(0, 0, W, H);

    var f = this.frame();
    var k = W / f.w;
    var st = this.state;
    fx.save();
    fx.translate(W / 2 + st.panX * k, H / 2 + st.panY * k);
    fx.rotate(this.angle() * DEG);
    fx.scale(st.zoom * k * st.flipX, st.zoom * k);
    fx.drawImage(this.img, -this.img.naturalWidth / 2, -this.img.naturalHeight / 2);
    fx.restore();

    var displayW = Math.max(200, Math.round(this.frame().w));
    var grid = this.canvasGrid();
    /* Two screen pixels per thread is the most that can show anything: past that
       the extra pixels only enlarge threads already fully resolved. */
    var outW = outWidthOverride
      ? Math.min(1600, grid.across * 2)
      : Math.min(1600, displayW * 2);
    var woven = window.BSWeaveSim.weave(flat, {
      threadsAcross: grid.across,
      dither: this.cfg.wovenDither,
      palette: this.palette(),                  // the mill's real yarns, when known
      outWidth: outW
    });

    // the mill's two-pixel rule, measured on the actual weave grid.
    if (woven.__grid && window.BSWeaveSim.detailRisk) {
      this.detail = window.BSWeaveSim.detailRisk(woven.__grid);
      this.updateQuality();
    }

    if (outWidthOverride) return woven;       // for the dialog; the page keeps its own

    var el = this.el.woven;
    el.width = woven.width; el.height = woven.height;
    el.getContext('2d').drawImage(woven, 0, 0);
    if (this.el.wovenWrap) this.el.wovenWrap.hidden = false;
    return woven;
  };

  /* ---- Loader: strands gathering into a ball -----------------------------
     Threads fly in from off-canvas, wind onto a sphere, tighten, and the
     cloth appears. Drawn on a small canvas so it costs nothing, and shaped as
     a real winding: each strand is a great circle on a rotating sphere, which
     is why it reads as a ball of yarn rather than a spinner.
     -------------------------------------------------------------------- */
  var LOADER_COLOURS = ['#CBDE88', '#AEC763', '#8CA64E', '#F6F9E8', '#6E8B3D', '#DBE5BA'];

  BSCustomizer.prototype.showLoader = function (on) {
    var el = this.el.loader;
    if (!el) return;
    if (!on) {
      el.classList.remove('is-on');
      cancelAnimationFrame(this._loadRaf);
      return;
    }
    this._loadStart = Date.now();
    el.classList.add('is-on');

    var cv = el.querySelector('canvas');
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var S = 168;
    cv.width = S * dpr; cv.height = S * dpr;
    var c = cv.getContext('2d');
    c.scale(dpr, dpr);

    var N = 14;
    var strands = [];
    for (var i = 0; i < N; i++) {
      strands.push({
        tilt: (i / N) * Math.PI,                  // plane of this great circle
        phase: Math.random() * Math.PI * 2,
        speed: 0.9 + Math.random() * 0.8,
        colour: LOADER_COLOURS[i % LOADER_COLOURS.length],
        width: 2.1 + Math.random() * 1.8,
        delay: i * 0.028
      });
    }

    var self = this;
    var t0 = performance.now();
    (function frame(now) {
      var t = (now - t0) / 1000;
      c.clearRect(0, 0, S, S);
      var cx = S / 2, cy = S / 2, R = S * 0.30;

      for (var i = 0; i < strands.length; i++) {
        var st = strands[i];
        var life = Math.max(0, Math.min(1, (t - st.delay) / 0.55));   // fly-in
        if (life <= 0) continue;
        var ease = 1 - Math.pow(1 - life, 3);

        // Each strand winds a great circle; the sphere turns as it goes.
        var spin = t * st.speed + st.phase;
        var tilt = st.tilt + t * 0.35;

        c.beginPath();
        for (var k = 0; k <= 48; k++) {
          var a = (k / 48) * Math.PI * 2;
          // point on a great circle, then rotate the sphere
          var x0 = Math.cos(a), y0 = Math.sin(a) * Math.cos(tilt), z0 = Math.sin(a) * Math.sin(tilt);
          var xr = x0 * Math.cos(spin) - z0 * Math.sin(spin);
          var zr = x0 * Math.sin(spin) + z0 * Math.cos(spin);
          // perspective, and the radius closes in as the ball gathers
          var persp = 0.72 + 0.28 * (zr + 1) / 2;
          var rr = R * (1.42 - 0.42 * ease);   // stays on canvas throughout
          var px = cx + xr * rr * persp;
          var py = cy + y0 * rr * persp;
          if (k === 0) c.moveTo(px, py); else c.lineTo(px, py);
        }
        c.globalAlpha = 0.55 + 0.45 * ease;
        c.strokeStyle = st.colour;
        c.lineWidth = st.width;
        c.lineCap = 'round';
        c.stroke();
      }
      c.globalAlpha = 1;
      self._loadRaf = requestAnimationFrame(frame);
    })(performance.now());
  };

  BSCustomizer.prototype.setWovenEnabled = function (on) {
    var self = this;
    this.wovenOff = !on;

    if (!on) {
      this.root.classList.remove('is-woven');
      this.setWovenReveal(0);
      this.showLoader(false);
      return;
    }

    if (!this.img) return;

    /* Build behind the loader. The weave takes 100-300ms and the animation is
       the honest cover for it, not decoration bolted on afterwards. */
    this.showLoader(true);
    clearTimeout(this._wovenT);
    clearTimeout(this._wovenHideT);
    setTimeout(function () {
      self.buildWoven();
      var wait = Math.max(0, 900 - (Date.now() - self._loadStart));
      setTimeout(function () {
        self.showLoader(false);
        self.root.classList.add('is-woven');
        self.setWovenReveal(1);
      }, wait);
    }, 30);
  };

  BSCustomizer.prototype.setWovenReveal = function (v) {
    this.state.wovenReveal = v;
    if (this.el.wovenWrap) {
      this.el.wovenWrap.style.opacity = v;
      this.el.wovenWrap.hidden = v < 0.01;
    }
    if (this.el.wovenLbl) {
      this.el.wovenLbl.textContent = v > 0.5 ? 'Woven preview' : 'Your photo';
    }
  };

  BSCustomizer.prototype.render = function () {
    if (!this.img) return;
    var st = this.state;
    this.el.img.style.transform =
      'translate(-50%, -50%) translate(' + st.panX + 'px,' + st.panY + 'px) ' +
      'rotate(' + this.angle() + 'deg) scale(' + (st.zoom * st.flipX) + ',' + st.zoom + ')';
    this.updateQuality();
    this.scheduleWoven();
  };

  BSCustomizer.prototype.syncSliders = function () {
    var st = this.state;
    if (this.el.zoom) {
      this.el.zoom.min = '1';
      this.el.zoom.max = '3';
      this.el.zoom.step = '0.01';
      this.el.zoom.value = String(st.zoom / st.minZoom);
    }
    if (this.el.zoomOut) this.el.zoomOut.textContent = Math.round(st.zoom / st.minZoom * 100) + '%';
    if (this.el.straightOut) this.el.straightOut.textContent = st.straighten.toFixed(1) + '°';
  };

  /* ---- Quality ---------------------------------------------------------

     Two independent things can ruin a woven blanket, and they need separate
     checks because a photo can fail either one alone:

       1. RESOLUTION  — are there enough pixels across the blanket?
                        Measured after crop and zoom, since zooming in throws
                        pixels away.
       2. COMPRESSION — are those pixels clean, or JPEG mush? Measured as
                        bytes per pixel. A 10MB file that was upscaled from a
                        screenshot is worse than a crisp 218KB photo.

     File size alone is NOT used as a gate. It says nothing on its own: a photo
     of a plain wall compresses to a fraction of a photo of foliage at identical
     resolution. Bytes-per-pixel is the part of file size that carries signal.

     Nothing here ever blocks the order. It advises, and says plainly when we
     can't guarantee the result.
     -------------------------------------------------------------------- */

  // How many photo pixels land across the blanket's width, after crop.
  BSCustomizer.prototype.effectivePPI = function () {
    if (!this.img) return 0;
    var f = this.frame();
    var d = this.dims();
    var sourcePxAcross = f.w / this.state.zoom;
    return sourcePxAcross / d.w;
  };

  // Whole-file size in MB. Simple, and it's the number the customer can see
  // for themselves in their photo library.
  BSCustomizer.prototype.fileMB = function () {
    return this.sourceFile ? this.sourceFile.size / (1024 * 1024) : null;
  };

  BSCustomizer.prototype.assess = function () {
    var t = this.cfg.quality || {};
    var lowPPI  = t.low       || 8;    // genuinely too few pixels to weave
    var warnMB  = t.warnMB    || 1;    // below this, say quality isn't guaranteed

    var ppi = this.effectivePPI();
    var mb  = this.fileMB();
    var d   = this.dims();
    /* The customer's own dimensions, not the working copy's — a warning that
       quoted our resample back at them would be nonsense. */
    var haveW = this.srcW || this.img.naturalWidth, haveH = this.srcH || this.img.naturalHeight;

    // Hard floor: not enough pixels for the loom to make anything of.
    if (ppi < lowPPI) {
      return {
        level: 'bad',
        title: 'Quality not guaranteed at this size',
        body: 'This photo is ' + haveW + ' \u00d7 ' + haveH + ', which is small for a ' + d.w +
              '" blanket. You can still order it. Change the photo for guaranteed results, ' +
              'or zoom out to use more of it. If a photo can\'t be woven, we\'ll reach out ' +
              'before making anything.'
      };
    }

    // Under a megabyte: order freely, but we don't promise the result.
    if (mb !== null && mb < warnMB) {
      var shown = mb < 1 ? Math.round(mb * 1024) + ' KB' : mb.toFixed(1) + ' MB';
      return {
        level: 'warn',
        title: 'Quality not guaranteed at this file size',
        body: 'This photo is ' + shown + '. Smaller files often still weave beautifully. '  +
              'Plenty of our blankets have come from photos this size, but we can\'t ' +
              'guarantee it. Change the photo for guaranteed results, or go ahead and order: ' +
              'if a photo can\'t be woven, we\'ll reach out before making anything.'
      };
    }

    /* the mill's editing guidance: anything thinner than two pixels on the
       weave grid does not survive. Their artists fix that by hand; a customer
       uploading a photo cannot, so flag it instead of letting it arrive as a
       surprise. Only meaningful once the preview has actually been built. */
    if (this.detail && this.detail.strongShare > 0.13) {
      return {
        level: 'warn',
        title: 'Some fine detail may not weave',
        /* The first draft of this said a larger blanket would help. Measured
           across all six sizes it barely does (risk 0.244 on the smallest,
           0.235 on the largest) because the photo is scaled to fit whichever
           size is chosen, so the detail keeps its proportion. Advice the data
           does not support does not ship. */
        body: 'This photo has detail finer than the weave can hold. Thin lines, small text ' +
              'and fine patterns tend to soften or disappear in cloth. Turn on the woven ' +
              'preview to see exactly what carries through before you order.'
      };
    }

    return {
      level: 'good',
      title: 'Looks great',
      body: 'Plenty of detail for a ' + d.w + '" \u00d7 ' + d.h + '" blanket.'
    };
  };

  BSCustomizer.prototype.updateQuality = function () {
    var q = this.el.quality;
    if (!q || !this.img) return;
    var a = this.assess();
    var cls = a.level === 'good' ? 'good' : (a.level === 'warn' ? 'ok' : 'bad');
    q.className = 'bsc__quality is-shown bsc__quality--' + cls;
    q.innerHTML = '<strong>' + a.title + '</strong>' + a.body;
  };

  /* ---- Image loading --------------------------------------------------- */

  /* Phones hand over photographs far larger than anything downstream can use.
     A 99-megapixel file is roughly 400MB of texture once decoded, and it was
     being held that way: the <img> on screen carried every one of those pixels
     while being drawn into a box a few hundred pixels wide, and every weave
     rebuild drew the whole thing again. That is what made a large photo fail to
     appear at all on a device with less memory to give.

     So the photograph is resampled once, on arrival, and nothing downstream ever
     sees the original again. 4000px on the long edge is not an arbitrary cap: it
     is what maxExportPx already clamps the upload to, and the loom itself
     resolves at most 1150 threads across the widest blanket sold — so the pixels
     being dropped here could never have reached the cloth. */
  var WORK_MAX = 4000;

  /* A backstop, not a quality judgement. Decoding materialises width x height x 4
     bytes whatever the file weighs, so a 990-megapixel image asks for roughly
     4GB and locks the tab hard — measured: the renderer stopped answering at
     all, and Shopify's own image CDN refuses the same file with "Transformation
     failed". Above this we say so plainly instead of hanging.

     500MP, deliberately back up so the real question can be answered. The mobile
     crash arrived after several BLANKET SIZE CHANGES, not on load, which points
     at the five throwaway canvases each weave rebuild used to allocate rather
     than at the pixel count. Those are now reused. 500 lets Nate's 469MP
     photograph through again, so a phone test either clears the megapixel
     theory or confirms it. If it still dies, the ceiling is the answer and this
     comes down; if it survives, megapixels were never the cause. 495MP was tested twice and passed both times —
     through the canvas resample and through the scaled decode — at 183ms and
     219ms, using 86MB of heap. 990MP is where it dies, and it dies hard: the
     renderer stops answering and the tab has to be killed.

     Everything between 495MP and 990MP is untested. The limit sits at the proven
     end of that gap, not in the middle of it, because the failure at the far end
     is a locked page rather than a slow one.

     Two earlier guesses are the reason this is spelled out. 700MP was picked by
     interpolation; 300MP was then picked for caution and immediately refused a
     real 469MP photograph. Panoramas and scans genuinely reach these sizes —
     phone sensors top out at 200MP. If a larger file needs to be supported, test
     that size first and move this to what the test shows. */
  var MAX_SOURCE_PX = 500e6;

  /* The floor. The smallest blanket is 768 x 545 threads, so anything under this
     cannot fill even one thread per pixel across the cloth. */
  var MIN_SOURCE_EDGE = 200;

  /* Reading the header is how we can know the size BEFORE committing to a
     decode. Both formats put the dimensions in the first few bytes, so this
     costs one small slice of the file rather than the whole image. */
  function readImageSize(file) {
    return new Promise(function (resolve) {
      var slice = file.slice(0, 131072);
      var fr = new FileReader();
      fr.onerror = function () { resolve(null); };
      fr.onload = function () {
        try {
          var v = new DataView(fr.result);
          if (v.byteLength > 24 && v.getUint32(0) === 0x89504E47) {      // PNG
            resolve({ w: v.getUint32(16), h: v.getUint32(20) });
            return;
          }
          if (v.byteLength > 4 && v.getUint16(0) === 0xFFD8) {           // JPEG
            var o = 2;
            while (o + 9 < v.byteLength) {
              if (v.getUint8(o) !== 0xFF) { o++; continue; }
              var m = v.getUint8(o + 1);
              // SOF0-3, 5-7, 9-11, 13-15 carry the frame dimensions
              if (m >= 0xC0 && m <= 0xCF && m !== 0xC4 && m !== 0xC8 && m !== 0xCC) {
                resolve({ h: v.getUint16(o + 5), w: v.getUint16(o + 7) });
                return;
              }
              o += 2 + v.getUint16(o + 2);
            }
          }
        } catch (e) { /* fall through */ }
        resolve(null);
      };
      fr.readAsArrayBuffer(slice);
    });
  }

  BSCustomizer.prototype.loadFile = function (file) {
    if (!file || /^image\//.test(file.type) === false) return;
    var self = this;
    this.setStatus('', '');

    /* SVG is a drawing, not a photograph: it has no fixed resolution, it can
       reference remote content, and a deeply nested one is a decode bomb. The
       loom needs pixels. */
    if (/svg/i.test(file.type)) {
      this.uploadError('That looks like a vector graphic (SVG). Please upload a photo: ' +
                     'a JPG, PNG or HEIC from your phone or camera.');
      return;
    }

    readImageSize(file).then(function (size) {
      /* Too small to be woven into anything. At 13.7 threads per inch even the
         smallest blanket is 545 threads down, so a postage-stamp image is not a
         quality warning, it is an impossibility — and it was being accepted with
         Add to cart live and the zoom sitting at 377x. */
      if (size && (size.w < MIN_SOURCE_EDGE || size.h < MIN_SOURCE_EDGE)) {
        self.uploadError('That photo is only ' + size.w + ' \u00d7 ' + size.h + ' pixels, which is ' +
                       'too small to weave. Please choose a larger one. Anything from a ' +
                       'phone camera is fine.');
        return;
      }
      if (size && size.w * size.h > MAX_SOURCE_PX) {
        self.uploadError(
          'That photo is ' + Math.round(size.w * size.h / 1e6) + ' megapixels (' +
          size.w + ' \u00d7 ' + size.h + '), which is too large for a browser to open. It ' +
          'would freeze the page. Almost any photo from a phone or camera is fine. ' +
          'If this one matters, resize it to under ' + Math.round(MAX_SOURCE_PX / 1e6) +
          ' megapixels and try again.');
        return;
      }
      self.decodeFile(file, size);
    });
  };

  BSCustomizer.prototype.decodeFile = function (file, size) {
    var self = this;
    var huge = size && Math.max(size.w, size.h) > WORK_MAX;

    /* createImageBitmap decodes off the main thread and, given a target size,
       lets the browser scale during the decode rather than building the full
       bitmap first and shrinking it afterwards. That is the difference between
       a large photo being slow and a large photo stopping the tab. Only used
       where it earns its keep: a photo already within the working size is
       displayed as it arrived, with no re-encode. */
    if (huge && window.createImageBitmap) {
      var k = WORK_MAX / Math.max(size.w, size.h);
      var cw = Math.max(1, Math.round(size.w * k)), ch = Math.max(1, Math.round(size.h * k));
      window.createImageBitmap(file, { resizeWidth: cw, resizeHeight: ch, resizeQuality: 'high' })
        .then(function (bmp) {
          var pc = document.createElement('canvas');
          pc.width = cw; pc.height = ch;
          pc.getContext('2d').drawImage(bmp, 0, 0, cw, ch);
          if (bmp.close) bmp.close();
          self.adoptWorkingCopy(pc, file, size.w, size.h);
        })
        .catch(function () { self.decodeViaImage(file); });
      return;
    }

    this.decodeViaImage(file);
  };

  /* The original path, kept for photos within the working size, for browsers
     without createImageBitmap, and as the fallback when a scaled decode fails. */
  BSCustomizer.prototype.decodeViaImage = function (file) {
    var self = this;
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      var w = img.naturalWidth, h = img.naturalHeight;
      self.srcW = w; self.srcH = h;

      if (Math.max(w, h) > WORK_MAX) {
        try {
          var k = WORK_MAX / Math.max(w, h);
          var cw = Math.max(1, Math.round(w * k)), ch = Math.max(1, Math.round(h * k));
          var pc = document.createElement('canvas');
          pc.width = cw; pc.height = ch;
          var pctx = pc.getContext('2d');
          pctx.imageSmoothingEnabled = true;
          pctx.imageSmoothingQuality = 'high';
          pctx.drawImage(img, 0, 0, cw, ch);
          URL.revokeObjectURL(url);
          self.adoptWorkingCopy(pc, file, w, h);
          return;
        } catch (e) { /* fall through and use it at full size */ }
      }

      self.img = img;
      self.sourceFile = file;
      self.showLoadedImage(url, w, h);
    };
    img.onerror = function () {
      URL.revokeObjectURL(url);
      self.uploadError('That file could not be opened. Try a JPG or PNG.');
    };
    img.src = url;
  };

  /* Takes the resampled canvas as the working image and hands the same pixels to
     the <img> on screen, so nothing downstream ever holds the original. */
  BSCustomizer.prototype.adoptWorkingCopy = function (pc, file, srcW, srcH) {
    var self = this;
    /* Everything downstream asks an image for naturalWidth/naturalHeight, so the
       working copy answers to the same names rather than making every call site
       care which it was handed. */
    Object.defineProperty(pc, 'naturalWidth',  { value: pc.width, configurable: true });
    Object.defineProperty(pc, 'naturalHeight', { value: pc.height, configurable: true });

    self.img = pc;
    self.sourceFile = file;
    /* The TRUE dimensions, kept for the quality warnings and the order record:
       those must describe what the customer sent, not the copy we made. */
    self.srcW = srcW; self.srcH = srcH;

    if (pc.toBlob) {
      pc.toBlob(function (b) {
        self.showLoadedImage(b ? URL.createObjectURL(b) : pc.toDataURL('image/jpeg', 0.92),
                             pc.width, pc.height);
      }, 'image/jpeg', 0.92);
    } else {
      self.showLoadedImage(pc.toDataURL('image/jpeg', 0.92), pc.width, pc.height);
    }
  };

  BSCustomizer.prototype.showLoadedImage = function (src, w, h) {
    this.clearUploadError();
    this.el.img.src = src;
    this.el.img.width = w;
    this.el.img.height = h;
    this.el.empty.hidden = true;
    this.el.blanket.classList.remove('is-flat');
    // The rotation belonged to the photo that just left.
    this.state.quarter = 0;
    this.refit();
    this.setSubmitEnabled(true);
    this.root.classList.add('has-photo');
    track('bs_photo_added', { width: w, height: h }, true);
  };

  BSCustomizer.prototype.setSubmitEnabled = function (on) {
    if (this.el.submit) this.el.submit.disabled = !on;
  };

  /* ---- Render the crop for upload ---------------------------------------------------------- */

  BSCustomizer.prototype.renderCrop = function () {
    var self = this;
    var f = this.frame();

    /* FiberArt validates the uploaded file against an exact pixel size per
       product and rejects anything else with "Image Pixel Size Out of Spec"
       (order blk1006). That size is the mill's own thread grid, one pixel per
       warp/weft crossover, which is exactly what canvasGrid returns and exactly
       what their SKU chart lists: CUS468N is 850x850, CUS470H is 1150x850, and
       so on. It is also why the file a person fixed by hand on blk1001 was
       named "resized". So the export size is no longer a quality judgement, it
       is a fixed contract, and canvasGrid already swaps for portrait the same
       way their V and H SKUs do.

       Hitting it can mean upscaling a tight crop. That is unavoidable when the
       mill dictates the pixel count, and the quality meter has already warned
       the customer long before they reach this point. */
    var g = this.canvasGrid();
    var ow = g.across, oh = g.down;

    var k = ow / f.w;                       // screen px -> export px
    var st = this.state;

    var cv = document.createElement('canvas');
    cv.width = ow; cv.height = oh;
    var ctx = cv.getContext('2d');
    ctx.imageSmoothingQuality = 'high';
    ctx.fillStyle = '#EDE6DC';
    ctx.fillRect(0, 0, ow, oh);

    ctx.save();
    ctx.translate(ow / 2 + st.panX * k, oh / 2 + st.panY * k);
    ctx.rotate(this.angle() * DEG);
    ctx.scale(st.zoom * k * st.flipX, st.zoom * k);
    ctx.drawImage(this.img, -this.img.naturalWidth / 2, -this.img.naturalHeight / 2);
    ctx.restore();

    return new Promise(function (resolve) {
      cv.toBlob(function (b) { resolve(b); }, 'image/jpeg', 0.92);
    });
  };

  BSCustomizer.prototype.designProps = function () {
    var d = this.dims();
    var st = this.state;
    return {
      'Size': d.w + '" x ' + d.h + '"',
      'Orientation': d.w >= d.h ? 'Landscape' : 'Portrait',
      '_zoom': st.zoom.toFixed(4),
      '_panX': st.panX.toFixed(2),
      '_panY': st.panY.toFixed(2),
      '_quarter': String(st.quarter),
      '_straighten': st.straighten.toFixed(2),
      '_flip': st.flipX === -1 ? 'yes' : 'no',
      '_sourcePx': this.img ? ((this.srcW || this.img.naturalWidth) + 'x' + (this.srcH || this.img.naturalHeight)) : '',
      '_effectivePPI': Math.round(this.effectivePPI()),
      '_detailRisk': this.detail ? this.detail.strongShare.toFixed(3) : '',
      '_weaveGrid': (function (g) { return g.across + 'x' + g.down + (g.published ? ' (mill spec)' : ' (derived)'); })(this.canvasGrid()),
      '_fileBytes': this.sourceFile ? this.sourceFile.size : '',
      '_fileMB': (this.fileMB() || 0).toFixed(2),
      '_qualityFlag': this.assess().level,
      '_frameRatio': (this.frame().w / this.frame().h).toFixed(4)
    };
  };

  /* ---- Cloudinary + cart ------------------------------------------------

     The order carries a Cloudinary URL, not an attached file. Order Desk reads
     that URL and hands it to the mill.

     The property names are a contract with FiberArt, which reads the item
     variations named print_url and print_sku. Order Desk imports every Shopify
     line item property as a variation under its exact name, so the name here is
     the name the mill sees. Getting this wrong fails the order at import.
     -------------------------------------------------------------------- */

  BSCustomizer.prototype.uploadToCloudinary = function (blob, filename, tags) {
    var cloud  = this.cfg.cloudName;
    var preset = this.cfg.uploadPreset;
    if (!cloud || !preset) {
      return Promise.reject(new Error('Cloudinary is not configured on this block.'));
    }
    var fd = new FormData();
    fd.append('file', blob, filename);
    fd.append('upload_preset', preset);
    if (tags) fd.append('tags', tags);

    return fetch('https://api.cloudinary.com/v1_1/' + cloud + '/image/upload', {
      method: 'POST', body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.secure_url) {
          throw new Error(data.error ? data.error.message : 'Upload failed');
        }
        /* public_id is handed back rather than left to be parsed out of the URL
           later. A delivery URL can legitimately carry transformation segments,
           which would break naive parsing — and the id is what an orders/paid
           webhook needs to move the asset out of the pending folder. */
        return { url: data.secure_url, publicId: data.public_id };
      });
  };

  BSCustomizer.prototype.addToCart = function (props) {
    var id = this.size().variantId || (this.el.variantIn && this.el.variantIn.value);
    if (!id) return Promise.reject(new Error('No variant selected for this size.'));
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: 1, properties: props })
    }).then(function (r) {
      if (r.ok) return r.json();
      return r.json().then(function (d) { throw new Error(d.description || 'Cart error'); });
    });
  };

  /* An upload that is refused has to say so where the customer is looking. The
     status line is beside Add to cart, which on a wide screen is a long way
     below the mock-up, so on its own it reads as nothing happening at all. */
  BSCustomizer.prototype.uploadError = function (msg) {
    track('bs_photo_refused', { reason: String(msg).slice(0, 80) }, true);
    this.setStatus(msg, 'error');
    var e = this.el.uploadErr;
    if (e) { e.textContent = msg; e.hidden = false; }
  };

  BSCustomizer.prototype.clearUploadError = function () {
    var e = this.el.uploadErr;
    if (e) { e.textContent = ''; e.hidden = true; }
  };

  /* Keeps the rail honest: the thumb is the share of the row you can see, placed
     at the share you have scrolled past. Hidden outright when everything fits,
     because a scroll hint over a row that does not scroll is a lie. */
  BSCustomizer.prototype.syncSizeRail = function () {
    var row = this.el.sizesWrap, rail = this.el.sizesRail, thumb = this.el.sizesThumb;
    if (!row || !rail || !thumb) return;

    var visible = row.clientWidth, total = row.scrollWidth;
    if (total <= visible + 2) { rail.hidden = true; return; }
    rail.hidden = false;

    /* The handle is capped well below the true visible share. Left proportional
       it filled most of a short rail — on this page the row shows 721 of 925, so
       a faithful handle is 78% of the bar and barely looks like one. Capped, it
       still shrinks as the row grows but always reads as a handle with somewhere
       to travel. The floor stops it becoming a speck. */
    var share = visible / total;
    if (share > 0.34) share = 0.34;
    if (share < 0.12) share = 0.12;
    var maxScroll = total - visible;
    var progress = maxScroll > 0 ? row.scrollLeft / maxScroll : 0;
    if (progress < 0) progress = 0;
    if (progress > 1) progress = 1;

    thumb.style.width = (share * 100) + '%';
    /* The thumb travels the rail minus its own width, so the right-hand end
       lines up with the end of the row rather than overshooting it. */
    thumb.style.transform = 'translateX(' + (progress * (100 - share * 100) / share) + '%)';
  };

  BSCustomizer.prototype.setStatus = function (msg, kind) {
    var el = this.el.status;
    if (!el) return;
    el.textContent = msg || '';
    el.className = 'bsc__status' + (kind ? ' bsc__status--' + kind : '');
  };

  /* A short id minted for each add-to-cart, written into BOTH the Cloudinary tags
     and the order line. It is the only way to tell a design that became an order
     from one abandoned in a cart — Cloudinary cannot know the difference, because
     the upload happens before the cart add and nothing ever goes back to update it.
     An asset whose id appears in no order is an orphan and safe to delete. */
  BSCustomizer.prototype.newDesignId = function () {
    var d = new Date();
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };
    var stamp = d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate());
    var rand = Math.random().toString(36).slice(2, 8).toUpperCase();
    return 'bs-' + stamp + '-' + rand;
  };

  /* Cloudinary tags. Commas separate tags, so nothing here may contain one. */
  BSCustomizer.prototype.uploadTags = function (designId) {
    var d = new Date();
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };
    var day = d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
    var dims = this.dims();
    return [
      'blanket',
      'design',
      'id-' + designId,
      'd-' + day,
      'size-' + dims.w + 'x' + dims.h,
      'v-' + (this.size().variantId || 'none')
    ].join(',');
  };

  /* Add to cart opens a confirmation first. A woven blanket looks different
     from a photo on a screen, and this is the last moment it can be changed —
     but the dialog says "take one more look", not "are you sure", because the
     job is a second glance, not a warning. */
  BSCustomizer.prototype.submit = function () {
    if (!this.img) return;
    track('bs_add_pressed', { size: (this.size() && this.size().name) || '' }, true);
    if (this.simple) {
      /* No dialog: the button itself is the approval. The weave is still
         built so _detailRisk is measured exactly as the dialog used to. */
      try { this.buildWoven(); } catch (e) {}
      this.doSubmit();
      return;
    }
    this.openConfirm();
  };

  BSCustomizer.prototype.openConfirm = function () {
    var m = this.el.confirm;
    if (!m) { this.doSubmit(); return; }          // dialog missing: never block the sale

    /* .bsc declares container-type: inline-size, which implies contain: layout.
       That makes .bsc the containing block for any fixed-position descendant and
       gives it its own stacking context, so this dialog's inset:0 covered only
       the customizer rather than the viewport, and its z-index competed only
       inside .bsc. The result on a phone was panel text painting over the dialog
       with the buttons unreachable until you scrolled. Moving the node to the
       body once puts it back on the viewport. Same trap, same fix, as the header
       submenu. The only variable it inherits from .bsc is --bsc-fringe, which is
       14px there and 14px as the fallback here, so nothing moves visually. */
    if (m.parentNode !== document.body) document.body.appendChild(m);

    /* Show the woven version, building it if the customer never switched it on.
       buildWoven draws synchronously, so the snapshot is safe to take at once. */
    var img = this.el.confirmImg;
    if (img && this.el.woven) {
      /* The weave sim will not resolve finer than one pixel per two threads —
         below that the dither survives as grain that varies by size, which is
         the coarseness bug from earlier. So this IS the full resolution
         available, and asking for more only costs a second render. */
      try {
        this.buildWoven();
        img.src = this.el.woven.toDataURL('image/jpeg', 0.92);
      } catch (e) { img.removeAttribute('src'); }

    }

    /* The tick is cleared every time the dialog opens, so it is always an
       affirmative act on this design rather than a leftover from a previous
       look. Nothing else gates the sale: if the checkbox is absent because the
       setting is off, syncAck leaves the confirm button enabled. */
    if (this.el.ack) this.el.ack.checked = false;
    this.syncAck();

    this._lastFocus = document.activeElement;
    m.hidden = false;
    track('bs_confirm_shown', {}, true);
    document.documentElement.style.overflow = 'hidden';
    var go = this.el.confirmGo;
    if (go && go.focus) go.focus();
  };

  /* Enables the confirm button only once the box is ticked. No checkbox in the
     markup (the setting is off) means no gate, which keeps the old promise that
     a missing dialog never blocks a sale. */
  BSCustomizer.prototype.syncAck = function () {
    var go = this.el.confirmGo;
    if (!go) return;
    if (!this.el.ack) { go.disabled = false; go.removeAttribute('aria-disabled'); return; }
    var ok = !!this.el.ack.checked;
    go.disabled = !ok;
    go.setAttribute('aria-disabled', ok ? 'false' : 'true');
  };

  /* Captured the moment they press the confirm button, not when the upload
     finishes, so the timestamp is the act itself. The wording is stored
     verbatim: if it is ever reworded in the theme editor, an older order still
     shows what that customer actually agreed to, which is the whole point of
     keeping it. Underscore names, so Shopify keeps them out of the cart and
     checkout display, the same way the other design metadata already rides
     along. */
  BSCustomizer.prototype.ackProps = function () {
    /* Simple mode: pressing "add to cart" under the approval line is the
       agreement, so the line shown is what gets stored. */
    if (this.simple && this.el.ackInline) {
      return {
        '_ack': 'yes',
        '_ackAt': new Date().toISOString(),
        '_ackText': (this.el.ackInline.textContent || '').trim()
      };
    }
    if (!this.el.ack || !this.el.ack.checked) return null;
    var txt = this.el.ackText ? (this.el.ackText.textContent || '').trim() : '';
    return {
      '_ack': 'yes',
      '_ackAt': new Date().toISOString(),
      '_ackText': txt
    };
  };

  /* proceeding = true only from the dialog's own Add button, which closes the
     dialog before submitting; every other close is the customer backing out. */
  BSCustomizer.prototype.closeConfirm = function (proceeding) {
    var m = this.el.confirm;
    if (!m) return;
    if (!m.hidden && !proceeding) track('bs_confirm_cancelled', {}, true);
    m.hidden = true;
    document.documentElement.style.overflow = '';
    if (this._lastFocus && this._lastFocus.focus) this._lastFocus.focus();
  };

  BSCustomizer.prototype.doSubmit = function () {
    var self = this;
    if (!this.img) return;

    /* One sale at a time. Disabling the button is not the same guard: this runs
       from the confirmation dialog's own button too, and the whole chain is
       async — a second entry would upload the photo to Cloudinary twice and add
       two lines to the cart. */
    if (this._submitting) return;
    this._submitting = true;

    var btn = this.el.submit;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Preparing your design…';
    this.setStatus('', '');

    var designId = this.newDesignId();
    var ack = this.ackProps();

    this.renderCrop()
      .then(function (blob) {
        btn.textContent = 'Uploading your photo…';
        return self.uploadToCloudinary(blob, designId + '.jpg', self.uploadTags(designId));
      })
      .then(function (up) {
        var props = self.designProps();
        /* Order Desk imports every line item property as an item VARIATION under
           its exact name, and FiberArt reads the variations named print_url and
           print_sku. Verified against order #blk1001, the only custom order that
           ever reached the mill: a person typed those two variations onto the
           item by hand. The names are the contract. Do not rename them. */
        props['print_url'] = up.url;
        var fiberSku = (self.size() && self.size().sku) || '';
        if (fiberSku) props['print_sku'] = fiberSku;
        props['_designId'] = designId;
        props['_cloudinaryId'] = up.publicId;
        /* Added last and only as extra keys. print_url and print_sku above are
           the FiberArt contract and are not read, renamed or reordered here. */
        if (ack) { for (var k in ack) { if (ack.hasOwnProperty(k)) props[k] = ack[k]; } }
        return props;
      })
      .then(function (props) {
        btn.textContent = 'Adding to cart…';
        return self.addToCart(props);
      })
      .then(function () {
        btn.textContent = 'Added';
        btn.classList.add('is-added');
        track('bs_added', { size: (self.size() && self.size().name) || '' }, true);
        if (window.bsCartAdded) window.bsCartAdded({ button: null });
        self.setStatus('Your design is saved. Taking you to your cart…', 'ok');
        setTimeout(function () { window.location.href = '/cart'; }, 900);
      })
      .catch(function (err) {
        console.error('[bs-customizer]', err);
        track('bs_add_failed', { message: String(err && err.message || err).slice(0, 80) }, true);
        /* Released only on failure. Success navigates to the cart, and staying
           locked until then is what stops a second submission in the gap. */
        self._submitting = false;
        btn.disabled = false;
        btn.textContent = label;
        self.setStatus(
          (err && err.message ? err.message : 'Something went wrong') +
          '. Your photo has not been lost, please try again.', 'error');
      });
  };

  /* ---- Events ---------------------------------------------------------- */

  BSCustomizer.prototype.bind = function () {
    var self = this, el = this.el;

    if (el.sizesWrap) {
      el.sizesWrap.addEventListener('scroll', function () { self.syncSizeRail(); }, { passive: true });
      if (window.ResizeObserver) {
        new ResizeObserver(function () { self.syncSizeRail(); }).observe(el.sizesWrap);
      }
      window.addEventListener('resize', function () { self.syncSizeRail(); });
      self.syncSizeRail();
    }

    el.sizes.forEach(function (b, i) {
      b.addEventListener('click', function () { self.selectSize(i); });
    });
    el.orient.forEach(function (b) {
      b.addEventListener('click', function () { self.setOrientation(b.dataset.bscOrient); });
    });
    if (el.rotate) el.rotate.addEventListener('click', function () { self.rotate90(); });

    if (el.flip) el.flip.addEventListener('click', function () {
      self.state.flipX *= -1; self.render(); self.rememberFraming();
    });

    if (el.reset) el.reset.addEventListener('click', function () {
      self.state.flipX = 1; self.refit();
    });

    if (el.zoom) el.zoom.addEventListener('input', function () {
      self.state.zoom = self.state.minZoom * parseFloat(el.zoom.value);
      self.clampAll(); self.syncSliders(); self.render(); self.rememberFraming();
    });

    if (el.straight) el.straight.addEventListener('input', function () {
      self.state.straighten = parseFloat(el.straight.value);
      self.clampAll(); self.syncSliders(); self.render(); self.rememberFraming();
    });

    // File input + drag/drop + click-to-browse
    el.file.addEventListener('click', function () { track('bs_upload_opened', { hadPhoto: !!self.img }, true); });
    el.file.addEventListener('change', function () {
      if (el.file.files && el.file.files[0]) self.loadFile(el.file.files[0]);
    });
    if (el.change) el.change.addEventListener('click', function () { el.file.click(); });
    if (el.uploadCta) el.uploadCta.addEventListener('click', function () { el.file.click(); });
    el.window.addEventListener('click', function () { if (!self.img) el.file.click(); });

    ['dragenter', 'dragover'].forEach(function (t) {
      el.window.addEventListener(t, function (e) { e.preventDefault(); el.window.classList.add('is-over'); });
    });
    ['dragleave', 'drop'].forEach(function (t) {
      el.window.addEventListener(t, function (e) { e.preventDefault(); el.window.classList.remove('is-over'); });
    });
    el.window.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files[0]) self.loadFile(e.dataTransfer.files[0]);
    });

    /* Drag to pan — pointer events cover mouse and touch alike. */
    var dragging = false, lastX = 0, lastY = 0, pid = null;
    el.window.addEventListener('pointerdown', function (e) {
      if (!self.img) return;
      dragging = true; pid = e.pointerId; lastX = e.clientX; lastY = e.clientY;
      el.window.setPointerCapture(pid);
      el.window.classList.add('is-dragging');
    });
    el.window.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerId !== pid) return;
      self.state.panX += e.clientX - lastX;
      self.state.panY += e.clientY - lastY;
      lastX = e.clientX; lastY = e.clientY;
      self.clampAll(); self.render(); self.rememberFraming();
    });
    ['pointerup', 'pointercancel'].forEach(function (t) {
      el.window.addEventListener(t, function (e) {
        if (e.pointerId !== pid) return;
        dragging = false; el.window.classList.remove('is-dragging');
      });
    });

    /* Wheel to zoom */
    el.window.addEventListener('wheel', function (e) {
      if (!self.img) return;
      e.preventDefault();
      var factor = e.deltaY < 0 ? 1.06 : 1 / 1.06;
      self.state.zoom = clamp(self.state.zoom * factor, self.state.minZoom, self.state.minZoom * 3);
      self.clampAll(); self.syncSliders(); self.render(); self.rememberFraming();
    }, { passive: false });

    /* Pinch to zoom */
    var pts = new Map(), startDist = 0, startZoom = 1;
    el.window.addEventListener('pointerdown', function (e) { pts.set(e.pointerId, e); });
    el.window.addEventListener('pointermove', function (e) {
      if (!pts.has(e.pointerId)) return;
      pts.set(e.pointerId, e);
      if (pts.size !== 2 || !self.img) return;
      var a = [...pts.values()];
      var dist = Math.hypot(a[0].clientX - a[1].clientX, a[0].clientY - a[1].clientY);
      if (!startDist) { startDist = dist; startZoom = self.state.zoom; return; }
      self.state.zoom = clamp(startZoom * (dist / startDist), self.state.minZoom, self.state.minZoom * 3);
      self.clampAll(); self.syncSliders(); self.render(); self.rememberFraming();
    });
    ['pointerup', 'pointercancel'].forEach(function (t) {
      el.window.addEventListener(t, function (e) { pts.delete(e.pointerId); startDist = 0; });
    });

    if (el.wovenToggle) {
      el.wovenToggle.addEventListener('change', function () {
        self.setWovenEnabled(el.wovenToggle.checked);
        track('bs_woven_toggled', { on: el.wovenToggle.checked }, true);
      });
      self.wovenOff = !el.wovenToggle.checked;
    }

    self.setWovenReveal(0);

    if (el.confirm) {
      el.confirm.querySelectorAll('[data-bsc-confirm-cancel]').forEach(function (b) {
        b.addEventListener('click', function () { self.closeConfirm(); });
      });
      // Clicking the backdrop is a cancel, the same as Escape.
      if (el.ack) el.ack.addEventListener('change', function () { self.syncAck(); });
      el.confirm.addEventListener('click', function (e) {
        if (e.target === el.confirm) self.closeConfirm();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !el.confirm.hidden) self.closeConfirm();
      });
      if (el.confirmGo) el.confirmGo.addEventListener('click', function () {
        self.closeConfirm(true);
        self.doSubmit();
      });
    }

    if (el.submit) el.submit.addEventListener('click', function (e) {
      e.preventDefault(); self.submit();
    });

    /* Re-clamp when the stage is resized (rotation, breakpoints, zoom). */
    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        self.applyRatio();
        if (!self.img) return;
        self.clampAll(); self.syncSliders(); self.render();
      }).observe(el.stage || el.window);
    }
  };

  /* ---- Boot ------------------------------------------------------------- */

  function init() {
    document.querySelectorAll('[data-bs-customizer]').forEach(function (root) {
      if (root.__bsc) return;
      try { root.__bsc = new BSCustomizer(root); }
      catch (err) { console.error('[bs-customizer] failed to start', err); }
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  window.BSCustomizer = BSCustomizer;
})();
